import { CaptionsConfig } from 'blocks/TextOverlayModal/v2';
import { TranscriptionFormValue } from 'containers/TranscriptionForm';
import { CaptionsOverride, Dimensions } from 'types';
import { getBaseCaptionsOverride } from 'utils/embed/captions/utils';
import { Pixels } from 'utils/measurement';
import { measurementToViewport } from 'utils/placement';
import { updateState } from '../../shared/mutations';
import { VideoTemplateStateContent } from '../../types';
import { getCaptionsFromConfig } from './utils';

export function setCaptionsDimensions(
  state: VideoTemplateStateContent,
  placement: Dimensions<Pixels>,
): VideoTemplateStateContent {
  const { canvas } = state;
  const { height, width, top, left } = measurementToViewport(placement, canvas);

  return updateState(state, {
    captions: {
      hasBeenEdited: true,
      position: {
        left,
        top,
      },
      size: {
        height,
        width,
      },
    },
  });
}

export function setTranscription(
  state: VideoTemplateStateContent,
  transcription: TranscriptionFormValue,
): VideoTemplateStateContent {
  return updateState(state, { transcription });
}

export function setCaptions(
  state: VideoTemplateStateContent,
  captions: CaptionsConfig,
): VideoTemplateStateContent {
  return updateState(state, { captions });
}

export function updateCaptionsConfig(
  state: VideoTemplateStateContent,
  captions?: CaptionsOverride,
): VideoTemplateStateContent {
  return updateState(state, { captions });
}

export function setInitialCaptionsConfig(
  state: VideoTemplateStateContent,
  transcription: TranscriptionFormValue,
  isFullEpisode?: boolean,
): VideoTemplateStateContent {
  if (!transcription?.transcribe) {
    return state;
  }

  if (transcription.transcribe && state.captions) {
    return state;
  }

  const baseCaptionsOverride = getCaptionsFromConfig(
    getBaseCaptionsOverride(state.aspectRatio, isFullEpisode),
  );

  return updateState(state, { captions: baseCaptionsOverride });
}
